import React from "react";

import { getCertificate } from "@services/certificateService";
import { showErrorToast } from "@shared/toasts/Toasts";

export const useGetCertificate = () => {
    const [data, setData] = React.useState<API.Certificate | null>(null);
    const [isLoading, setIsLoading] = React.useState(true);

    const refetch = React.useCallback(() => {
        setIsLoading(true);
        return getCertificate()
            .then((response) => setData(response))
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err.message);
            })
            .finally(() => setIsLoading(false));
    }, []);

    React.useEffect(() => {
        setIsLoading(true);
        void refetch().finally(() => setIsLoading(false));
    }, [refetch]);

    return { data, isLoading, refetch };
};
